import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@5.2.1@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-video_player_start",
  "use": "icon-video_player_start-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-video_player_start\">\n<path d=\"M18 10.268C19.3333 11.0378 19.3333 12.9623 18 13.7321L10.5 18.0622C9.16666 18.832 7.5 17.8697 7.5 16.3301L7.5 7.66987C7.5 6.13027 9.16667 5.16802 10.5 5.93782L18 10.268Z\" stroke-width=\"1.5\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol